import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";
import { useMutation } from "@apollo/client";

import { UPDATE_BOOKING } from '../../../GraphQL/Mutations/bookings';

import { LoadingIcon } from '../../Common/Loading_Icon';
import { setList, setOverlay, configureBookingDictionary } from '../../../Actions/stakeholderActions';
import { setBookingsDb, setProfileDb, setReturnReleaseBookings } from '../../../Actions/dataActions';
import { Trans } from 'react-i18next';


const RejectButton = ({ legacyApiRejectAction }) => {
    // const [updateBookingMutation, { data, loading, error }] = useMutation(UPDATE_BOOKING);

    // [not in use due to queue data sync implementation]
    const updateBookingGraphQL = ({ status, id }) => {
        // const bookingInput = {
        //     id: parseInt(id),
        //     status,
        // }

        // updateBookingMutation({ variables: { input: bookingInput } }).then((response) => {
        //     // showStatusMsg('Booking changes saved successfully', 'success');

        //     window.location.reload();
        // }).catch((error) => {
        //     console.error('[updateBookingMutation] error: ', error);
        // });
    }

    const rejectAction = () => legacyApiRejectAction(updateBookingGraphQL);

    return (
        <a className = "button alert float-right" onClick={rejectAction}><Trans>Reject</Trans></a>
    )
}

class InviteOverlay extends Component {
    constructor(props) {    
        super(props);

        this.state = {
            notes: "",
            booking: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.rejectAction = debounce(this.rejectAction.bind(this), 500);

    }

    componentDidMount() {
        var self = this;

        if(this.props.rejectType == "booking")
        {
            axios.get('/ajax/booking/' + this.props.match.params.id)
            .then(function(response) {
                self.setState({
                    booking: response?.data.booking
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
        }
    }

    componentWillReceiveProps(nextProps) {
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    rejectAction(updateBookingGraphQL) {
        var self = this;

        axios({
            method: 'post',
            url: '/ajax/' + (this.props.rejectType == "booking" ? "booking/" : "profile/" ) + this.props.match.params.id + '/reject/notes',
            data: {notes: self.state.notes},
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then((response) => {
            if (self.props.rejectType === "booking") {
                // [not in use due to queue data sync implementation]
                // updateBookingGraphQL({
                //     id: self.props.match.params.gqlID,
                //     status: 'denied'
                // })

                window.location.reload();

                if (self.props.match.url.split("/")[1] === "bookings" || self.props.match.url.split("/")[1] === "home") {
                    var data = { search_term: $("#searchbar").val(),
                                vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                                sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'),
                                start_date: self.props.stakeholder.current_date.clone().subtract(3, 'weeks'),
                                end_date: self.props.stakeholder.current_date.clone().add(3, 'weeks')
                            }
                            
                    if (self.props.stakeholder.booking_next_page !== null && self.props.stakeholder.booking_next_page > 0) {
                        data['grab_all_pages'] = self.props.stakeholder.booking_next_page;
                    }
                    
                    axios({
                        method: 'post',
                        url: '/ajax/calendar/bookings',
                        data: data
                    })
                    .then(function(response2) {
                        self.props.dispatch(setList("SET_CURRENT_BOOKINGS_LIST", response2.data.bookings_list));
                        self.props.dispatch(configureBookingDictionary(response2.data.bookings_list, response2.data.holidays, self.props.stakeholder.organized_bookings))
                        self.props.dispatch(setList("SET_BOOKING_REQUEST_LIST", response2.data.pending_bookings));
                        self.props.dispatch(setReturnReleaseBookings(response2.data.return_release_bookings));
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
            
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
            
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }

                if ("vehicle" in self.props.stakeholder.current_vehicle_details && "booking" in self.props && self.props.booking.V_ID === self.props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                    axios.get('/ajax/vehicle/' + self.props.booking.V_ID)
                    .then(function(response2) {
                        self.props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }
    
                if ("profile" in self.props.stakeholder.current_profile_details && self.props.booking.Profile_ID === self.props.stakeholder.current_profile_details.profile.ID) {
                    axios.get('/ajax/profile/' + self.props.booking.Profile_ID)
                    .then(function(response2) {
                        self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }

                if (self.props.match.url.split("/")[1] === "bookings") {
                    var data = { search_term: $("#searchbar").val(),
                                vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                                sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'),
                                start_date: self.props.stakeholder.current_date.clone().subtract(3, 'weeks'),
                                end_date: self.props.stakeholder.current_date.clone().add(3, 'weeks')
                            }
                            
                    if (self.props.stakeholder.booking_next_page !== null && self.props.stakeholder.booking_next_page > 0) {
                        data['grab_all_pages'] = self.props.stakeholder.booking_next_page;
                    }
                    
                    axios({
                        method: 'post',
                        url: '/ajax/calendar/bookings',
                        data: data
                    })
                    .then(function(response2) {
                        self.props.dispatch(setList("SET_CURRENT_BOOKINGS_LIST", response2.data.bookings_list));
                        self.props.dispatch(configureBookingDictionary(response2.data.bookings_list, response2.data.holidays, {}))
                    
                        var vehicles = Object.keys(response2.data.bookings_list)
                        for (var i = 0; i < vehicles.length; i++) {
                            self.props.dispatch(setBookingsDb(response2.data.bookings_list[vehicles[i]], self.props.data.bookings_db))
                        }
                    })
                }
            } else {

                var data = {};

                if(self.props.match.url.split("/")[1] === "useroverview") {
                    data =  { 
                        search_term: $("#searchbar").val(),
                        vmh: $("input[name='vmh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        sh: $("input[name='sh[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        status: $("input[name='status[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        tier: $("input[name='tier[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        company: $("input[name='company[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        title: $("input[name='title[]']:checked").map(function () { return this.value; }).get().join('#'), 
                        last_booking_min: $("#last_booking_min").text(),
                        last_booking_max: $("#last_booking_max").text(),
                        bookings_min: $("#bookings_min").text(),
                        bookings_max: $("#bookings_max").text(),
                        sort_filter: $("#sort_filter").val(),
                        sort_direction: $("#sort_direction").val(),
                    }
                }

                axios({
                    method: 'post',
                    url: '/ajax/user_list/update',
                    data: data
                })
                .then(function(response2) {
                    self.props.dispatch(setProfileDb(response2.data.customers, self.props.data.profile_db));
                    self.props.dispatch(setList("SET_USER_LIST", response2.data.customers))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })

                axios({
                    method: 'get',
                    url: '/ajax/dashboard/pendingusers',
                })
                .then(function(response2) {
                    self.props.dispatch(setList("SET_USER_REQUEST_LIST", response2.data.invites))
                })
                .catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
    
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
    
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })

                if ("vehicle" in self.props.stakeholder.current_vehicle_details && self.state.booking.V_ID === self.props.stakeholder.current_vehicle_details.vehicle.V_ID) {
                    axios.get('/ajax/vehicle/' + self.state.booking.V_ID)
                    .then(function(response2) {
                        self.props.dispatch(setOverlay("SET_CURRENT_VEHICLE_DETAILS", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }
    
                if ("profile" in self.props.stakeholder.current_profile_details && self.state.booking.Profile_ID === self.props.stakeholder.current_profile_details.profile.ID) {
                    axios.get('/ajax/profile/' + self.state.booking.Profile_ID)
                    .then(function(response2) {
                        self.props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
                    })
                    .catch(function(error) {
                        if(error.response?.status == 401){
                            showStatusMsg(error.response?.data.error);
                        } else if(error.response?.status == 422) {
                            var error_message = "";
        
                            $.each(error.response?.data.errors, function (index, element) {
                                error_message += element + '<br />';
                            });
        
                            showStatusMsg(error_message);
                        } else {
                            showStatusMsg("Requested information not found");
                        }
                    })
                }
            }

            self.props.history.goBack();
            showStatusMsg(response?.data.message, 'success');
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    render(props) {
        return (
            <div id = "rejectrequest-overlay">
                <div className = "card">
                    <div className = "card-divider">
                        <span className = "card-header-title"><Trans>Reject</Trans> {this.props.rejectType == "booking" ? "Booking" : "User"}</span>
                    </div>
                    <div className = "card-section">
                        <label><Trans>Reason for Rejection</Trans>
                            <textarea name="notes" placeholder = "This note will be sent in an email to the user. Let him/her know why their request was rejected." onChange={this.handleChange} />
                        </label>
                        <span className = "caption mt-8">
                            { this.props.rejectType == "booking" ?
                                    <span><Trans>These notes will be shared with the user who has made this booking.</Trans></span>
                                :
                                    <span><Trans>Rejected users will not have access to the portal</Trans></span>
                            }
                        </span>
                    </div>
                    <div className = "card-button-section">
                        <RejectButton legacyApiRejectAction={this.rejectAction} />
                        <a className = "button float-right" onClick={this.props.history.goBack}><Trans>Cancel</Trans></a>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(InviteOverlay)